import {
  ModifierRadioItem,
  ModifierCheckboxItem,
  ModifierTextArea,
} from "@/components/productDetail/ProductModifier/ModifierInputItems";
import { ExclamationCircleIcon } from "@heroicons/react/solid";

const ModifierGroupSection = ({
  mode,
  modifierGroup,
  index,
  inputType,
  errors,
  touched,
  handleChange,
  setFieldTouched,
}) => {
  const inputTypeElementName =
    inputType === "radio"
      ? "radioChecked"
      : inputType === "checkbox"
      ? "checkboxGroup"
      : "requestRemark";

  const validationError = errors[inputTypeElementName];
  const itemTouched = touched?.modifierGroups?.[index]?.[inputTypeElementName];

  const showErrorMessage =
    mode === "edit"
      ? (inputType !== "text") & (modifierGroup.selectionRangeMin > 0) &&
        validationError
      : (inputType !== "text") & (modifierGroup.selectionRangeMin > 0) &&
        itemTouched &&
        validationError;

  const getSectionInstructionText = () => {
    let instructionText = "";
    const min = modifierGroup.selectionRangeMin;
    const max = modifierGroup.selectionRangeMax;

    //guard clause for optional case
    if (inputType === "text" || min < 1) {
      instructionText = "Optional";
      return instructionText;
    }

    switch (inputType) {
      case "radio":
        instructionText = `Pick ${min}`;
        break;
      case "checkbox":
        instructionText = `Pick ${min} to ${max}`;
        break;
      default:
    }

    return instructionText;
  };

  return (
    <div key={modifierGroup.modifierGroupId} className="bg-white mt-5 mb-5">
      <div
        className={inputType !== "text" ? "pl-5 pr-5 pt-5" : "p-5"}
        name={`modifierGroups[${index}].modifierGroupName`}
      >
        <div className="flex justify-between items-center mb-5 h-[auto]">
          <div className="flex items-center w-[90%]">
            <h3 className="m-0 mr-3">{modifierGroup.modifierGroupName}</h3>
            <div
              className={
                (showErrorMessage
                  ? "bg-red-100 h-[1.5rem] p-1 pl-2 pr-2 text-red-600 font-bold rounded-lg "
                  : "") + "flex mt-1 whitespace-nowrap"
              }
            >
              <span className="text-xs m-0">{getSectionInstructionText()}</span>
            </div>
          </div>
          {showErrorMessage ? (
            <ExclamationCircleIcon className="w-5 h-5 text-red-500" />
          ) : undefined}
        </div>
        <>
          {inputType === "radio" && (
            <>
              {modifierGroup.modifier.map((modifier, i) => (
                <ModifierRadioItem
                  key={modifier.modifierId}
                  name={`modifierGroups[${index}].radioChecked`}
                  modifierName={modifier.modifierName}
                  value={modifier.modifierId}
                  className={
                    i + 1 === modifierGroup.modifier.length ? "border-b-0" : ""
                  }
                  price={modifier.price}
                  checked={modifierGroup.radioChecked === modifier.modifierId}
                />
              ))}
            </>
          )}
          {inputType === "checkbox" && (
            <>
              {modifierGroup.modifier.map((modifier, i) => (
                <div
                  role="group"
                  key={modifier.modifierId}
                  aria-labelledby="checkbox-group"
                >
                  <ModifierCheckboxItem
                    handleChange={handleChange}
                    name={`modifierGroups[${index}].checkboxGroup`}
                    modifierName={modifier.modifierName}
                    price={
                      modifier.priceWithTax
                        ? modifier.priceWithTax
                        : modifier.price
                    }
                    value={modifier.modifierId}
                    className={
                      i + 1 === modifierGroup.modifier.length
                        ? "border-b-0"
                        : ""
                    }
                    checked={
                      modifierGroup.checkboxGroup?.includes(
                        modifier.modifierId
                      ) ?? false
                    }
                  />
                </div>
              ))}
            </>
          )}
          {inputType === "text" && (
            <ModifierTextArea name={`modifierGroups[${index}].requestRemark`} />
          )}
        </>
      </div>
    </div>
  );
};

const ModifierList = ({ formikProps, mode }) => {
  return (
    <>
      {formikProps.values.modifierGroups.length > 0 &&
        formikProps.values.modifierGroups.map((modifierGroup, index) => {
          if (
            ((modifierGroup.inputType === "radio" ||
              modifierGroup.inputType === "checkbox") &&
              modifierGroup.modifier?.length > 0) ||
            modifierGroup.inputType === "text"
          ) {
            return (
              <ModifierGroupSection
                mode={mode}
                key={modifierGroup.modifierGroupId}
                modifierGroup={modifierGroup}
                index={index}
                inputType={modifierGroup.inputType}
                {...formikProps}
              />
            );
          }
        })}
    </>
  );
};

export default ModifierList;
